import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import sessions from './modules/sessions'

export default new Vuex.Store({
  modules: {
    sessions
  }
})
